import DebouncedInput from "./DebouncedInput"

const Filter = ({ column }) => {
  const columnFilterValue = column.getFilterValue()
  const { filterVariant, options } = column.columnDef.meta

  return filterVariant === "select" ? (
    <select
      className="px-2 py-1 text-sm text-gray-600 bg-white rounded-md shadow border"
      value={columnFilterValue?.toString()}
      onChange={(e) => column.setFilterValue(e.target.value)}
    >
      {options.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  ) : (
    <DebouncedInput
      className="w-36 border text-sm shadow rounded px-2 py-1"
      placeholder="Search"
      type="text"
      value={columnFilterValue ?? ""}
      onChange={(value) => column.setFilterValue(value)}
    />
  )
}

export default Filter
